module.exports = __webpack_public_path__ + "img/metro_L2.6ed0556d.svg";